export class Topic {
  constructor(
    public indskr_topic: string,
    public indskr_topicname: string,
    public isChecked?: boolean,
    public indskr_consentId?: string,
    public indskr_purpose?: string,
    public indskr_complianceprofile?: string
  ) {}
}

export class TopicMapping {
  constructor(
    public topicChannel: string,
    public topic: string,
    public topicName: string,
    public purpose: string,
    public purposeName: string,
    public complianceProfile: string,
    public complianceProfileName: string
  ) {}
}
